import {
  EditorState,
  Modifier,
  RichUtils,
  getDefaultKeyBinding,
  KeyBindingUtil,
} from 'draft-js';
const { isOptionKeyCommand } = KeyBindingUtil;

const plugin = {
  keyBindingFn: e => {
    if (e.shiftKey && e.keyCode === 13) {
      return 'insert-soft-line-break';
    }
    return getDefaultKeyBinding(e);
  },
  handleKeyCommand: (command, editorState, timeStamp, { getProps }) => {
    const { onChange, inlineStyleServices } = getProps();
    if (command === 'insert-soft-line-break') {
      onChange(RichUtils.insertSoftNewline(editorState));
      return 'handled';
    }
    if (command !== 'split-block') return 'not-handled';
    const selection = editorState.getSelection();
    const startKey = selection.getStartKey();
    const contentState = editorState.getCurrentContent();
    const block = contentState.getBlockForKey(startKey);
    const blockType = block.getType();
    const newContent = Modifier.splitBlock(contentState, selection);
    const splitToUnstyled =
      inlineStyleServices.findIndex(s => s.blockType === blockType) === -1;
    if (splitToUnstyled) {
      onChange(
        EditorState.push(
          editorState,
          Modifier.setBlockType(
            newContent,
            newContent.getSelectionAfter(),
            'unstyled',
          ),
          'split-block',
        ),
      );
      return 'handled';
    }
    return 'not-handled';
  },
};

export default plugin;
